import _ from "lodash";
import * as z from "../../../framework";
import * as ui from "../ui";
import * as realTimeUpdates from "../util/realTimeUpdates";

var Report = function () {
    this.currentReport = null;
    this.reportList = [];
    this.buildReportDropDown();
};

enum paramTypes {
    BOOLEAN = "BOOLEAN",
    DATE = "DATE",
    DATETIME = "DATETIME",
    DIVISION = "DIVISION",
    DROPDOWN = "DROPDOWN",
    ENDINGLOOKUP = "ENDINGLOOKUP",
    IDLOOKUP = "IDLOOKUP",
    INT = "INT",
    STARTINGLOOKUP = "STARTINGLOOKUP",
    TIME = "TIME"
}

Report.prototype = {
    /*
     * buildReportDropDown
     * Builds the report drop down in top right corner so users can select a report to ru
     *
     */
    buildReportDropDown: function () {
        var me = this,
            HTML = {};

        // TODO: IF it is in local storage do not reload
        var reportList = z.getLocalStorage("ReportList"),
            setupReportDropDown = function () {
                if ($("li[id=ReportMenu]").length > 0) {
                    var menu = new ui.DropdownMenu("#ReportAdminBanner");
                    $.each(me.reportList, function (index, report) {
                        var reportType = _.find(
                            z.codes.ReportType,
                            function (type) {
                                return type.Id == report.ReportTypeId;
                            }
                        );

                        if (reportType) {
                            report.ReportType = reportType;
                            if (!HTML[report.ReportType.CodeNumber]) {
                                HTML[report.ReportType.CodeNumber] = true;
                                menu.append(
                                    {
                                        classes: "banner-menu report-category",
                                        id:
                                            "ReportCategory_" +
                                            report.ReportType.CodeNumber,
                                        content: report.ReportType.Value
                                    },
                                    "#ReportMenu"
                                );
                            }
                            menu.append(
                                {
                                    content: z.ll(report.FileName),
                                    id: report.FileName,
                                    classes: "banner-menu",
                                    data: { Report: report },
                                    onSelect: function (item) {
                                        me.initReportPopUp(
                                            $(item).data("Report")
                                        );
                                    }
                                },
                                "#ReportCategory_" +
                                    report.ReportType.CodeNumber
                            );
                        }
                    });
                }
            };

        if (reportList) {
            me.reportList = $.parseJSON(reportList);
            setupReportDropDown();
        } else {
            z.ajax({
                type: "GET",
                url:
                    "Report/?" +
                    "$select=FileName, Description, ReportTypeId, ReportParameter/ParameterName, ReportParameter/ParameterType, " +
                    "ReportParameter/ServicesOnlyParameter, ReportParameter/DefaultValue, ReportParameter/Required, " +
                    "ReportParameter/ReportParameterOption/Value, ReportParameter/ReportParameterOption/Label&" +
                    "$expand=ReportParameter/ReportParameterOption&" +
                    "$filter=InDropDown eq true&" +
                    "$top=5000"
            }).done(function (data) {
                me.reportList = data.d.results;
                z.setLocalStorage("ReportList", JSON.stringify(me.reportList));
                setupReportDropDown();
            });
        }
    },

    /*
     * InitReportPopUp
     * Build the report pop up screen off of templates
     *
     */
    initReportPopUp: function (data) {
        var me = this,
            reportObservable = z.observable({}),
            autocompleteIds = [],
            dropdownIds = [],
            startingEndingGroups = {};

        var buildEditHTML = function () {
            var components: ui.Component[] = [];

            components.push(
                new ui.Container({
                    bsc: "col-xs-12",
                    components: [
                        new ui.Checkbox({
                            id: "PrinterFriendly",
                            label: "PrinterFriendly",
                            bindValue: "PrinterFriendly",
                            containerClasses:
                                "col-xs-12 report-checkbox mar-b-10"
                        })
                    ]
                }),
                new ui.ComboBox({
                    label: "SelectFormat",
                    bindValue: "FormatId",
                    bsc: "col-xs-6 no-pad",
                    labelField: "CodeNumber",
                    bindNumberValue: "null",
                    valueField: "Id",
                    id: "Format",
                    required: true,
                    systemCode: true
                })
            );

            var sortedReportParameters = _.sortBy(
                data.ReportParameter as any[],
                parameter => {
                    switch (parameter.ParameterName) {
                        case "DivisionNumber":
                            return 0;
                        case "RegionNumber":
                            return 1;
                        default:
                            return 2;
                    }
                }
            );

            _.forEach(sortedReportParameters, parameter => {
                var parameterName = parameter.ParameterName,
                    parameterType = parameter.ParameterType,
                    idIndex = parameterName.lastIndexOf("Id"),
                    numberIndex = parameterName.lastIndexOf("Number"),
                    entityType = "",
                    startingOrEnding = false;

                if (idIndex != -1 && idIndex + 2 == parameterName.length) {
                    entityType = parameterName.substring(0, idIndex);
                    parameterName = entityType + "Number";
                    parameterType = paramTypes.IDLOOKUP;
                } else if (
                    numberIndex != -1 &&
                    numberIndex + 6 == parameterName.length
                ) {
                    entityType = parameterName.substring(0, numberIndex);
                    if (entityType == "Division") {
                        parameterType = paramTypes.DIVISION;
                    } else {
                        parameterType = paramTypes.IDLOOKUP;
                    }
                } else if (parameter.ReportParameterOption.length > 0) {
                    parameterType = paramTypes.DROPDOWN;
                }

                if (entityType.indexOf("Starting") == 0) {
                    entityType = entityType.substring(8);
                    parameterType = paramTypes.STARTINGLOOKUP;
                    if (!startingEndingGroups[entityType]) {
                        startingEndingGroups[entityType] = {};
                    }

                    startingEndingGroups[entityType].start = parameterName;
                    startingEndingGroups[entityType].entityType = entityType;
                } else if (entityType.indexOf("Ending") == 0) {
                    entityType = entityType.substring(6);
                    parameterType = paramTypes.ENDINGLOOKUP;
                    if (!startingEndingGroups[entityType]) {
                        startingEndingGroups[entityType] = {};
                    }

                    startingEndingGroups[entityType].end = parameterName;
                } else if (parameterName.indexOf("Starting") == 0) {
                    let temp = entityType.substring(8);
                    if (!startingEndingGroups[temp]) {
                        startingEndingGroups[temp] = {};
                    }

                    startingEndingGroups[temp].start = parameterName;
                    startingOrEnding = true;
                } else if (parameterName.indexOf("Ending") == 0) {
                    let temp = entityType.substring(6);
                    if (!startingEndingGroups[temp]) {
                        startingEndingGroups[temp] = {};
                    }

                    startingEndingGroups[temp].end = parameterName;
                    startingOrEnding = true;
                }

                var component: ui.Component;
                const componentArgs = {
                    bsc: "col-xs-6 no-pad",
                    label: parameterName,
                    bindValue: parameterName,
                    required: parameter.Required,
                    id: parameterName
                };

                var extraClass;
                switch (parameterType) {
                    case paramTypes.BOOLEAN:
                        let toggleArgs = {
                            ...componentArgs,
                            bsc: "col-xs-6 no-pad h-35",
                            toolTip: parameterName,
                            labelTrue: "True",
                            labelFalse: "False",
                            bindValue: parameterName
                        };
                        component = new ui.Toggle(toggleArgs);
                        reportObservable.set(
                            parameterName,
                            parameter.DefaultValue == "true" ? true : false
                        );
                        break;
                    case paramTypes.INT:
                        component = new ui.NumericInput(componentArgs);
                        reportObservable.set(
                            parameterName,
                            parameter.DefaultValue != null
                                ? parseInt(parameter.DefaultValue, 10)
                                : null
                        );
                        break;
                    case paramTypes.IDLOOKUP:
                        let idLookupArgs = {
                            ...componentArgs,
                            iconClasses: "vam",
                            iconType: "list",
                            iconId: parameterName + "ReportLookUp"
                        };
                        component = new ui.TextBox(idLookupArgs);
                        autocompleteIds.push({
                            entityType: entityType,
                            id: parameterName
                        });
                        break;
                    case paramTypes.STARTINGLOOKUP:
                    case paramTypes.ENDINGLOOKUP:
                        extraClass =
                            "start-" + parameterName.toLowerCaseFirstLetter();
                        if (parameterType == paramTypes.ENDINGLOOKUP) {
                            extraClass =
                                "end-" + parameterName.toLowerCaseFirstLetter();
                        }
                        let lookupArgs = {
                            ...componentArgs,
                            iconClasses: "vam " + extraClass,
                            iconType: "list",
                            iconId: parameterName + "ReportLookUp"
                        };
                        component = new ui.TextBox(lookupArgs);
                        autocompleteIds.push({
                            entityType: entityType,
                            id: parameterName,
                            startEnd: true
                        });
                        break;
                    case paramTypes.DROPDOWN:
                        let dropDownListArgs = {
                            ...componentArgs,
                            template: "#= z.ll(data.Label) #",
                            dataValueField: "Value",
                            dataTextField: "Label",
                            valueTemplate: "#= z.ll(data.Label) #",
                            dataSource: parameter.ReportParameterOption
                        };
                        component = new ui.DropDownList(dropDownListArgs);
                        dropdownIds.push({
                            entityType: entityType,
                            id: parameterName
                        });
                        reportObservable.set(
                            parameterName,
                            parameter.DefaultValue != null
                                ? _.find(
                                      parameter.ReportParameterOption,
                                      function (d) {
                                          return (
                                              d.Value === parameter.DefaultValue
                                          );
                                      }
                                  ) || parameter.ReportParameterOption[0]
                                : 0
                        );
                        break;
                    case paramTypes.DIVISION:
                        let divisionArgs = {
                            ...componentArgs,
                            labelField: "DivisionNumber",
                            bindNumberValue: "null",
                            valueField: "DivisionNumber",
                            entityType: "Division",
                            systemCode: true
                        };
                        component = new ui.ComboBox(divisionArgs);
                        break;
                    case paramTypes.DATE:
                    case paramTypes.DATETIME:
                    case paramTypes.TIME:
                        let dateTimeArgs = {
                            ...componentArgs,
                            classes: undefined
                        };
                        if (startingOrEnding) {
                            extraClass =
                                "start-" +
                                parameterName.toLowerCaseFirstLetter();
                            if (parameterType == paramTypes.ENDINGLOOKUP) {
                                extraClass =
                                    "end-" +
                                    parameterName.toLowerCaseFirstLetter();
                            }
                            dateTimeArgs.classes = extraClass;
                        }
                        if (parameterType == paramTypes.DATE) {
                            component = new ui.DateInput(dateTimeArgs);
                        } else if (parameterType == paramTypes.TIME) {
                            component = new ui.TimeInput(dateTimeArgs);
                        } else {
                            component = new ui.DateTimeInput(dateTimeArgs);
                        }
                        reportObservable.set(
                            parameterName,
                            parameter.DefaultValue != null
                                ? parameter.defaultValue
                                : null
                        );
                        break;
                    default:
                        let textBoxArgs = { ...componentArgs };
                        component = new ui.TextBox(textBoxArgs);
                        break;
                }

                components.push(component);
            });

            var layout = new ui.Container({
                classes: "report-container",
                components: [
                    new ui.Container({
                        type: "Container",
                        classes: "report-dynamic-create-container",
                        childBsc: "col-xs-6",
                        components: components
                    })
                ]
            });

            layout.options.zScreen = popUp;

            return layout;
        };

        var correlationGroupId;
        var reportName = z.ll(data.FileName);
        var popUp = z.controls.popUp({
            id: "GenerateReport",
            title: z.ll("GenerateReportHeader").format(reportName),
            width: 900,
            buttons: [
                { name: z.ll("Cancel") },
                {
                    name: z.ll("ViewReport"),
                    id: "ViewReportButton",
                    clickEvent: function (e) {
                        e.preventDefault();
                        if (
                            popUp.get("#ViewReportButton").hasClass("disabled")
                        ) {
                            return;
                        }

                        window.open(
                            z.util.buildMediaUrl(
                                $(popUp.get("#ViewReportButton")).data(
                                    "AttachmentResponse"
                                )
                            )
                        );

                        popUp.get("#ViewReportButton").disable();

                        getReportAttachment(correlationGroupId);
                    }
                },
                {
                    name: z.ll("GenerateReportButtonText"),
                    className: "more-pad",
                    clickEvent: function (e) {
                        e.preventDefault();
                        var validator = popUp.guts.data("kendoValidator");
                        if (!validator.validate()) {
                            z.controls.alert({
                                message: z.ll("MandatoryFields"),
                                type: "danger"
                            });
                            return false;
                        }

                        popUp.window.wrapper.mask();
                        popUp.get("#ViewReportButton").disable();
                        var url =
                            "Report/Get/?id=" +
                            data.Id +
                            "&formatId=" +
                            reportObservable.FormatId;

                        for (var j = 0; j < data.ReportParameter.length; j++) {
                            var param = data.ReportParameter[j];

                            url += "&";

                            var parameterValue =
                                reportObservable[param.ParameterName];

                            var fieldName = "";

                            if ($.type(parameterValue) == "object") {
                                if (
                                    param.ParameterName.indexOf("Starting") == 0
                                ) {
                                    fieldName =
                                        param.ParameterName.substring(8);
                                    parameterValue =
                                        parameterValue[fieldName.toString()];
                                } else if (
                                    param.ParameterName.indexOf("Ending") == 0
                                ) {
                                    fieldName =
                                        param.ParameterName.substring(6);
                                    parameterValue =
                                        parameterValue[fieldName.toString()];
                                } else if (
                                    param.ParameterName == "DivisionNumber"
                                ) {
                                    const globalDivisionNumber =
                                        z.codes.Division[0].DivisionNumber;
                                    if (
                                        parameterValue?.DivisionNumber ==
                                        globalDivisionNumber
                                    ) {
                                        parameterValue = "undefined";
                                    } else {
                                        parameterValue =
                                            parameterValue.DivisionNumber;
                                    }
                                } else {
                                    parameterValue = parameterValue.Value;
                                }
                            }

                            url +=
                                param.ParameterName +
                                "=" +
                                encodeURIComponent(parameterValue);
                        }

                        url +=
                            "&PrinterFriendly=" +
                            (reportObservable.PrinterFriendly ? true : false);

                        correlationGroupId = kendo.guid();
                        var ajax = z.ajax({
                            type: "GET",
                            url: url,
                            correlationGroupId: correlationGroupId,
                            timeout: 0,
                            errorHandled: true,
                            success: function (reportResponse) {
                                z.util.ping({
                                    guid: reportResponse.d.results,
                                    correlationGroupId: correlationGroupId,
                                    unmask: function () {
                                        popUp.window.wrapper.unmask();
                                    },
                                    success: function (pingResponse) {
                                        $(popUp.get("#ViewReportButton")).data(
                                            "ReportResponse",
                                            pingResponse.d.results
                                        );

                                        var deferred =
                                            getReportAttachment(
                                                correlationGroupId
                                            );
                                        deferred.done(function () {
                                            z.util.loadDefaults();

                                            popUp
                                                .get("#ViewReportButton")
                                                .enable();

                                            popUp.window.wrapper.unmask();
                                            z.controls.alert({
                                                type: "success",
                                                header: z.ll(
                                                    "ReportRanSuccess"
                                                ),
                                                message: z.ll(
                                                    "ReportRanSuccessMessage"
                                                )
                                            });
                                        });
                                    }
                                });
                            }
                        });

                        ajax.fail(function () {
                            z.controls.alert({
                                message: z.ll("IssueGeneratingReport"),
                                type: "danger"
                            });
                            popUp.window.wrapper.unmask();
                        });
                    }
                }
            ]
        });

        var getReportAttachment = function (correlationGroupIdToUse) {
            return z
                .ajax({
                    url:
                        "Attachment/ActivateAttachment?id=" +
                        $(popUp.get("#ViewReportButton")).data(
                            "ReportResponse"
                        ),
                    type: "GET",
                    correlationGroupId: correlationGroupIdToUse,
                    async: false
                })
                .done(function (attachmentResponse) {
                    $(popUp.get("#ViewReportButton")).data(
                        "AttachmentResponse",
                        attachmentResponse.d.results
                    );
                    popUp.get("#ViewReportButton").enable();
                });
        };

        var reportView = buildEditHTML();
        reportView.render(popUp.guts);

        popUp.get("#ViewReportButton").disable();

        realTimeUpdates.registerCodeDataSource(
            popUp.get("#Format"),
            "ReportFormat"
        );

        $.each(autocompleteIds, function (index, options) {
            var schema = z.schemas[options.entityType],
                columns: any[] = [
                    {
                        width: 200,
                        data: "data." + options.entityType + "Number || '---'",
                        headerLabel: z.ll(options.entityType + "Number"),
                        columnClasses: "data-column"
                    }
                ];

            if (schema && !schema.Properties[options.entityType + "Name"]) {
                if (schema.Properties.Description) {
                    columns.push({
                        width: 180,
                        data: "data.Description ? data.Description : '---'",
                        headerLabel: z.ll("Description")
                    });
                }
            } else if (
                schema &&
                schema.Properties[options.entityType + "Name"]
            ) {
                columns.push({
                    width: 180,
                    data:
                        "data." +
                        options.entityType +
                        "Name ? data." +
                        options.entityType +
                        "Name : '---'",
                    headerLabel: z.ll(options.entityType + "Name")
                });
            }

            var filter = z.filter.doesNotEqual(
                options.entityType + "Number",
                null
            );
            if (options.id == "RegionNumber") {
                filter = filter.andEquals(
                    "EmployeeRegion/UserId",
                    z.user.loginData.UserId
                );
            }
            var filterString = filter.toString();

            var autoComplete = z.controls.autoComplete({
                id: popUp.id + "_" + options.id,
                entityType: options.entityType,
                dataTextField: options.entityType + "Number",
                divisions: false, // in case the user selects a different division
                filterExpression: filterString,
                templateJSON: {
                    columns: columns
                }
            });
            if (!options.startEnd) {
                autoComplete.bind("select", function (e) {
                    var result = this.dataItem(e.item.index());
                    reportObservable[options.entityType + "Number"] =
                        result[options.entityType + "Number"];
                    reportObservable[options.entityType + "Id"] = result.Id;
                });

                autoComplete.bind("change", function (e) {
                    reportObservable[options.entityType + "Number"] =
                        this.value();
                });

                popUp
                    .get("#" + options.id + "ReportLookUp")
                    .tie("click", function () {
                        var searchPopUp = z.controls.searchPopUp({
                            id: options.entityType + "SearchPopup",
                            title: z.ll("Entity." + options.entityType),
                            codeColumnsToIgnore: ["ParentRegionId"],
                            types: [
                                z.searchTypes.generate({
                                    entityType: options.entityType,
                                    filter: filterString,
                                    divisions: false
                                })
                            ],
                            okClick: function () {
                                var searchWindow = searchPopUp.window;
                                if (searchWindow.searchResults != null) {
                                    var result = searchWindow.searchResults;
                                    autoComplete.value(
                                        result[options.entityType + "Number"]
                                    );
                                    reportObservable[
                                        options.entityType + "Number"
                                    ] = result[options.entityType + "Number"];
                                    reportObservable[
                                        options.entityType + "Id"
                                    ] = result.Id;
                                }
                            }
                        });
                    });
            }
        });

        var keys = Object.keys(startingEndingGroups);

        for (var ii = 0; ii < keys.length; ii++) {
            var startEndObject = startingEndingGroups[keys[ii]];

            if (startEndObject.start.indexOf("Number") != -1) {
                z.util.startEndNumbers({
                    entityType: startEndObject.entityType,
                    searchPopUpIcons: popUp.get(
                        "#" +
                            startEndObject.start +
                            "ReportLookUp, #" +
                            startEndObject.end +
                            "ReportLookUp"
                    ),
                    startPopUpIconClass:
                        "start-" +
                        startEndObject.start.toLowerCaseFirstLetter(),
                    endPopUpIconClass:
                        "end-" + startEndObject.end.toLowerCaseFirstLetter(),
                    startingElem: popUp.get("#" + startEndObject.start),
                    endingElem: popUp.get("#" + startEndObject.end),
                    observable: reportObservable
                });
            } else {
                z.util.startEndDateTimes({
                    startingProperty: startEndObject.start,
                    endingProperty: startEndObject.end,
                    startingElem: popUp.get("#" + startEndObject.start),
                    endingElem: popUp.get("#" + startEndObject.end),
                    observable: reportObservable
                });
            }
        }

        z.util.addDefaults({
            singleEntity: data.FileName,
            observable: reportObservable
        });

        z.bind({
            container: popUp.get("#GenerateReport"),
            bind: ".bind-value",
            data: reportObservable
        });
        z.bind({
            container: popUp.get("#GenerateReport"),
            bind: ".bind-label",
            data: z.LocalizedLanguage
        });

        reportObservable.bind("change", function () {
            popUp.get("#ViewReportButton").disable();
        });

        $.each(dropdownIds, function (index, options) {
            var element = popUp.get("#" + options.id),
                elementData = element.data(),
                ddl = element.data("kendoDropDownList"),
                value = ddl.value(),
                colonIndex = elementData.bind.indexOf(":"),
                property = elementData.bind.substring(colonIndex + 2);

            reportObservable.set(property, value[property] || value);
        });

        var divisionNumberDropdown = popUp.get("#DivisionNumber"),
            regionNumberDropdown = popUp.get("#RegionNumber");

        if (divisionNumberDropdown) {
            realTimeUpdates.registerCodeDataSource(
                divisionNumberDropdown,
                "Division"
            );
        }

        if (divisionNumberDropdown) {
            var defaultDivision = _.find(z.codes.Division, function (r) {
                return r.Id == z.user.companyData.EmployeeDivisionId;
            });
            reportObservable.set("DivisionNumber", defaultDivision);
        }

        if (regionNumberDropdown) {
            var defaultRegionNumber = _.find(z.codes.Region, function (r) {
                return r.Id == z.user.companyData.EmployeeDefaultRegionId;
            }).RegionNumber;
            reportObservable.set("RegionNumber", defaultRegionNumber);
        }

        if (!z.user.companyData.DivisionAndRegionEnabled) {
            popUp.get("#RegionNumber_cid").addClass("hidden");
        }

        popUp.get("#GenerateReport").find(".bind-value:first").focus();

        popUp.guts.zValidator();
    }
};

export default Report;
